export const ASSETS = {
  logo: "/sineann-emblem.png",
  logoFull: "/sineann-logo.png",
  heroVineyard: "https://images.pexels.com/photos/18248851/pexels-photo-18248851.jpeg",
  heroAlt: "https://images.pexels.com/photos/4070538/pexels-photo-4070538.jpeg",
  cellar: "https://images.unsplash.com/photo-1724082111671-eb2a4c01d40d",
  winemaker: "/winemaker.png",
  labelPoster: "/story-poster.png",
  wineDetail: "https://images.unsplash.com/photo-1561461056-77634126673a",
  graffiti: "https://images.unsplash.com/photo-1648154008739-bd1b8cbb9074",
  label: "https://static.prod-images.emergentagent.com/jobs/867d0ff3-124f-4696-8f78-054541efb08c/images/88c1a025feabf91a3e6d74e0c889e67287ee00e99c149b57124077412e85867a.png",
};
